import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IContactProps } from "entity/contact/Contact/Contact.api.types";

const Contact = lazyLoadComponent(() => import("./Contact"));

export const RouteContact = (
    props: Omit<IContactProps, "id" | "isFromSelector" | "history" | "match" | "location">,
) => (
    <RouteRelative
        path={routes.contact.details}
        render={(routeProps) => {
            const id = parseInt(routeProps.match.params.id);
            const isFromSelector =
                routeProps.match.params.isFromSelector?.toLowerCase() === "true" || false;

            return <Contact {...props} {...routeProps} id={id} isFromSelector={isFromSelector} />;
        }}
    />
);
